<template>
  <RightSideBar
    v-if="isOpen"
    :loading="isLoading"
    @close="isOpen=false"
    button-class="bg-dynamicBackBtn text-white"
    :close-button="true"
    width="width:42rem"
  >
    <template v-slot:title>
      <p class="text-darkPurple font-bold">
        View Details
      </p>
    </template>
    <template v-slot:subtitle>
      <div class="flex flex-col">
        <EmployeeDetails
          :employee-info="oldEmployeeInfo"
          title="EMPLOYEE DETAILS (OLD)"
        />
        <EmployeeDetails
          :employee-info="newEmployeeInfo"
          title="EMPLOYEE DETAILS (NEW)"
          :has-border="false"
        />
      </div>
    </template>
    <template v-if="Object.keys(requestInfo).length">
      <div class="flex flex-col justify-start items-start gap-2 w-full">
        <div class="w-full flex justify-between items-stretch gap-2">
          <Card class="w-1/2 flex justify-start items-start gap-2 p-3">
            <Icon icon-name="icon-grid" class="text-romanSilver mt-1" size="xs" />
            <div class="flex flex-col justify-start items-start">
              <h6 class="font-normal text-xs text-blueCrayola">Relocation Allowance</h6>
              <p class="font-semibold text-jet text-xs uppercase">
                {{ formatRelocationAllowance(requestInfo) }}
              </p>
            </div>
          </Card>
          <Card class="w-1/2 flex justify-start items-start gap-2 p-3">
            <Icon icon-name="calendar" class="text-romanSilver mt-1" size="xs" />
            <div class="flex flex-col justify-start items-start">
              <h6 class="font-normal text-xs text-blueCrayola">Created</h6>
              <p class="font-semibold text-jet text-xs uppercase" v-if="requestInfo.createdAt">
                {{ $DATEFORMAT(new Date(requestInfo.createdAt), "MMMM dd, yyyy") }}
              </p>
              <p v-else class="font-semibold text-jet text-xs">-</p>
            </div>
          </Card>
        </div>
        <div class="w-full flex justify-between items-stretch gap-2">
          <Card class="w-1/2 flex justify-start items-start gap-2 p-3">
            <Icon icon-name="calendar" class="text-romanSilver mt-1" size="xs" />
            <div class="flex flex-col justify-start items-start">
              <h6 class="font-normal text-xs text-blueCrayola">Effective Date</h6>
              <p class="font-semibold text-jet text-xs uppercase" v-if="requestInfo.effectiveAt">
                {{ $DATEFORMAT(new Date(requestInfo.effectiveAt), "MMMM dd, yyyy") }}
              </p>
              <p v-else class="font-semibold text-jet text-xs">-</p>
            </div>
          </Card>
          <Card class="w-1/2 flex justify-start items-start gap-2 p-3">
            <Icon icon-name="icon-grid" class="text-romanSilver mt-1" size="xs" />
            <div class="flex flex-col justify-start items-start">
              <h6 class="font-normal text-xs text-carrotOrange">Initiated By</h6>
              <p class="font-semibold text-jet text-xs uppercase">
                <span v-if="requestInfo.initiatedBy">
                  {{ requestInfo.initiatedBy.fname || '' }} {{ requestInfo.initiatedBy.lname || '' }}
                </span>
                <span v-else>-</span>
              </p>
            </div>
          </Card>
        </div>
        <Card class="w-full flex justify-start items-start gap-2 p-3">
          <Icon icon-name="icon-grid" class="text-romanSilver mt-1" size="xs" />
          <div class="w-full flex flex-col justify-start items-start">
            <h6 class="font-normal text-xs text-flame">Approval Status</h6>
            <div class="flex justify-between w-full items-center">
              <p class="font-semibold text-jet text-xs uppercase">
                {{ formatStatus(requestInfo.approvalStatus) }}
              </p>
              <div @click="priviledgedActions(requestInfo.requestId)">
                <small class="text-blueCrayola cursor-pointer" style="font-size:10px">
                  View Trail
                </small>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </template>
  </RightSideBar>
</template>

<script>
import Card from "@scelloo/cloudenly-ui/src/components/card"
import RightSideBar from "@/components/RightSideBar"

export default {
  components: {
    Card,
    RightSideBar,
    EmployeeDetails: () => import('./details'),
  },
  props: {
    mode: {
      type: String,
      default: "admin",
    },
  },
  data(){
    return {
      isLoading: true,
      isOpen: false,
      oldEmployeeInfo: {},
      newEmployeeInfo: {},
      requestInfo: {},
    }
  },
  methods: {
    formatStatus(status) {
      if (!status) return '-';
      return status.split('_').join('-').toUpperCase();
    },
    formatRelocationAllowance(info) {
      if (info.relocationAllowanceAmount) {
        return this.convertToCurrency(info.relocationAllowanceAmount);
      }
      const allowance = info.relocationAllowance;
      if (allowance === true || allowance === 'true') {
        return 'Yes';
      }
      if (allowance === false || allowance === 'false') {
        return 'No';
      }
      return '-';
    },
    buildNewEmployeeInfo(payload) {
      const employee = payload.newDetails?.employee || {};
      const newDesignation = payload.newDetails?.newDesignation;
      const newLocation = payload.newDetails?.newLocation;
      const newManager = payload.newDetails?.newManager;
      const newPayInfo = employee.payInfo || {};

      return {
        fname: payload.fname,
        lname: payload.lname,
        photo: payload.photo,
        orgFunction: newDesignation?.orgFunction || payload.newDetails?.function || payload.orgFunction,
        userDesignation: newDesignation,
        userLevel: newDesignation?.level,
        employeeOffice: newLocation,
        userReportingTo: newManager,
        payInfo: newPayInfo,
        grossPay: employee.newGrossAnnualSalary,
      };
    },
    async priviledgedActions(requestId){
      try {
        if (this.mode === 'admin') {
          await this.$handlePrivilege('redeploymentHR', 'viewApprovalStatus')
        }
        this.$emit('trail', requestId)
      } catch (error) {
        const message = 'You do not have permission to perform this task'
        this.$toasted.error(message, { duration: 3000 })
      }
    },
    toggle(payload){
      this.isOpen = true

      const employee = payload.newDetails?.employee || {};

      this.oldEmployeeInfo = {
        ...payload,
        payInfo: payload.payInfo,
        grossPay: payload.payInfo?.grossPay,
      };

      this.newEmployeeInfo = this.buildNewEmployeeInfo(payload);

      this.requestInfo = {
        requestId: payload.id,
        createdAt: payload.createdAt || employee.createdAt,
        approvalStatus: payload.status,
        effectiveAt: payload.effectiveDate || employee.effectiveDate,
        initiatedBy: payload.newDetails?.initiatedBy,
        relocationAllowance: employee.relocationAllowance,
        relocationAllowanceAmount: employee.relocationAllowanceAmount,
      };

      this.isLoading = false
    },
  },
};
</script>
